import { render, staticRenderFns } from "./Toggler.vue?vue&type=template&id=63cfd064"
import script from "./Toggler.vue?vue&type=script&lang=js"
export * from "./Toggler.vue?vue&type=script&lang=js"
import style0 from "./Toggler.vue?vue&type=style&index=0&id=63cfd064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports